export const GUERNSEY_POSTCODE_PREFIX = 'GY';
export const JERSEY_POSTCODE_PREFIX = 'JE';

export const CHANNEL_ISLANDS_POSTCODE_PREFIXES = [GUERNSEY_POSTCODE_PREFIX, JERSEY_POSTCODE_PREFIX];
